import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type FollowingUser =
  paths['/api/v1/user_profiles/{user_profile_id}/followings']['get']['responses'][200]['content']['application/json']['followings'];

export type MutualFollowers =
  paths['/api/v1/user_profiles/mutual_follows']['get']['responses'][200]['content']['application/json']['mutualFollows'];

export async function getFollowingUsers(userProfileId: string): Promise<FollowingUser> {
  const { data, error } = await client.GET('/api/v1/user_profiles/{user_profile_id}/followings', {
    headers: authHeaders(),
    params: { path: { user_profile_id: userProfileId } }
  });
  if (error) throw new Error('Failed to get following users');
  if (!data) throw new Error('No data received');
  return data.followings;
}

export async function getMutualFollowers(): Promise<MutualFollowers> {
  const { data, error } = await client.GET('/api/v1/user_profiles/mutual_follows', {
    headers: authHeaders()
  });
  if (error) throw new Error('Failed to get mutual followers');
  if (!data) throw new Error('No data received');
  return data.mutualFollows;
}
